<script lang="ts">
import { clozeSourceText, renderCloze } from '$lib/render/cloze';
import type { ClozeCard } from '$types/card';
import RichText from './RichText.svelte';

interface Props {
  card: ClozeCard;
  revealed: boolean;
}

const { card, revealed }: Props = $props();
const sourceText = $derived(clozeSourceText(card));
const fallbackBack = $derived(card.text ? null : card.back);
</script>

<div class="card-cloze">
  <div class="card-text"><RichText content={renderCloze(sourceText, { hidden: !revealed })} /></div>
  {#if revealed && fallbackBack}
    <div class="card-back">
      <div class="back-label">↳ erklärung</div>
      <div class="back-body"><RichText content={fallbackBack} /></div>
    </div>
  {/if}
</div>

<style>
  .card-text {
    font-family: var(--font-body), 'Inter', system-ui, sans-serif;
    font-size: 22px;
    line-height: 1.35;
    color: var(--ink);
    font-weight: 500;
    letter-spacing: -0.01em;
    text-wrap: pretty;
  }
  @media (min-width: 600px) {
    .card-text { font-size: 26px; }
  }

  .card-text :global(.cloze-hidden),
  .card-text :global(.cloze-revealed) {
    display: inline-block;
    padding: 0 6px;
    font-family: var(--font-mono);
    font-weight: 700;
    border-bottom: 2px solid var(--accent);
  }
  .card-text :global(.cloze-hidden) {
    background: var(--ink);
    color: var(--ink);
    user-select: none;
  }
  .card-text :global(.cloze-revealed) {
    background: linear-gradient(transparent 60%, rgba(232, 81, 28, 0.25) 60%);
    color: var(--accent-2);
  }

  .card-back {
    margin-top: 18px;
    padding: 12px;
    background: var(--paper-2);
    border-left: 4px solid var(--accent);
    position: relative;
  }
  .card-back::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: repeating-linear-gradient(
      -45deg,
      transparent 0 6px,
      rgba(232, 81, 28, 0.04) 6px 7px
    );
    pointer-events: none;
  }
  .back-label {
    font-size: 10px;
    letter-spacing: 0.12em;
    color: var(--accent-2);
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 6px;
  }
  .back-body {
    font-family: var(--font-body), 'Inter';
    font-size: 14px;
    line-height: 1.55;
    color: var(--ink-2);
    position: relative;
  }
</style>
